/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_EstimateInputs */

const en_cost_estimate = /** @type {(inputs: Cost_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost Estimate`)
};

const fr_cost_estimate = /** @type {(inputs: Cost_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimation des coûts`)
};

const de_cost_estimate = /** @type {(inputs: Cost_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenvoranschlag`)
};

const it_cost_estimate = /** @type {(inputs: Cost_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preventivo dei costi`)
};

const ru_cost_estimate = /** @type {(inputs: Cost_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смета расходов`)
};

const es_cost_estimate = /** @type {(inputs: Cost_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimación de costos`)
};

const zh_cn2_cost_estimate = /** @type {(inputs: Cost_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成本估算`)
};

const ja_cost_estimate = /** @type {(inputs: Cost_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`費用見積もり`)
};

const hi_cost_estimate = /** @type {(inputs: Cost_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लागत का अनुमान`)
};

const pt_pt2_cost_estimate = /** @type {(inputs: Cost_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimativa de custos`)
};

/**
* | output |
* | --- |
* | "Cost Estimate" |
*
* @param {Cost_EstimateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cost_estimate = /** @type {((inputs?: Cost_EstimateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_EstimateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cost_estimate(inputs)
	if (locale === "de") return de_cost_estimate(inputs)
	if (locale === "it") return it_cost_estimate(inputs)
	if (locale === "ru") return ru_cost_estimate(inputs)
	if (locale === "es") return es_cost_estimate(inputs)
	if (locale === "zh-CN") return zh_cn2_cost_estimate(inputs)
	if (locale === "ja") return ja_cost_estimate(inputs)
	if (locale === "hi") return hi_cost_estimate(inputs)
	if (locale === "pt-PT") return pt_pt2_cost_estimate(inputs)
	return en_cost_estimate(inputs)
});